import imageCompression from 'browser-image-compression';

// Documents (ID / appendix / enrollment) must stay LEGIBLE, so compression is
// gentle: larger max dimension + higher quality than a typical avatar. PDFs pass
// through untouched.
const OPTIONS = {
  maxSizeMB: 1.5,
  maxWidthOrHeight: 2400,
  useWebWorker: true,
  fileType: 'image/jpeg' as const,
  initialQuality: 0.85,
};

export const MAX_FILE_SIZE = 10 * 1024 * 1024; // 10MB
export const ALLOWED_MIME_TYPES = ['image/jpeg', 'image/png', 'image/webp', 'application/pdf'];

export function isValidType(f: File): boolean {
  return ALLOWED_MIME_TYPES.includes(f.type);
}
export function isValidSize(f: File): boolean {
  return f.size <= MAX_FILE_SIZE;
}

export async function prepareForUpload(file: File): Promise<File> {
  if (file.type === 'application/pdf') return file; // never rasterize a PDF
  if (file.size <= OPTIONS.maxSizeMB * 1024 * 1024 && file.type === 'image/jpeg') return file;
  try {
    const compressed = await imageCompression(file, OPTIONS);
    return new File([compressed], file.name.replace(/\.[^/.]+$/, '.jpg'), {
      type: 'image/jpeg',
      lastModified: Date.now(),
    });
  } catch {
    return file; // fall back to the original if compression fails
  }
}

export function previewUrl(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
